import { Controller } from '@hotwired/stimulus'
import Appsignal from '@appsignal/javascript'
import { installErrorHandler } from '@appsignal/stimulus'
import { plugin as pluginBreadcrumbsNetwork } from '@appsignal/plugin-breadcrumbs-network'
import { plugin as pluginPathDecorator } from '@appsignal/plugin-path-decorator'

let appsignal = null

export default class extends Controller {
  static values = { configUrl: String }

  initialize () {
    this.load().then(this.configure)
  }

  configure (json) {
    if (json.key) {
      if (appsignal == null) {
        appsignal = new Appsignal(json)
        appsignal.use(pluginBreadcrumbsNetwork())
        appsignal.use(pluginPathDecorator())
        window.appsignal = appsignal

        installErrorHandler(appsignal, window.Stimulus)
      }
    }
  }

  load () {
    return fetch(this.configUrlValue,
      {
        mode: 'cors',
        cache: 'default',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(response => response.json())
  }
}
